export default "__VITE_ASSET__1mB2uepa__"